module.exports = __webpack_public_path__ + "static/tdcw-bc-back-dark-2620b765a9016ce866af6abeaf46b2b1.png";